import store from "@/store";

// 根据当前时间生成问候语
export const getGreet = () => {
  const now = new Date();
  const hour = now.getHours();
  let greet = "";
  if (hour < 5) {
    greet = "夜深了，注意身体哦！";
  } else if (hour < 9) {
    greet = "早上好！欢迎回来！";
  } else if (hour < 12) {
    greet = "上午好！欢迎回来！";
  } else if (hour < 14) {
    greet = "中午好！欢迎回来！";
  } else if (hour < 18) {
    greet = "下午好！欢迎回来！";
  } else if (hour < 24) {
    greet = "晚上好！欢迎回来！";
  } else {
    greet = "您好！欢迎回来！";
  }
  return greet;
};

/**
 * 根据id从数组获取数据项
 * @param {*} arr
 * @param {*} id
 * @returns
 */
export const idGetItem = (arr, id) => {
  let obj = null;
  arr.forEach((item) => {
    if (item.id == id) {
      obj = item;
    }
  });
  return obj;
};

/**
 * 将数据构建为ElTree的data {label:'', children: []}
 * @param data
 */
export const buildJsonToElTreeData = (data) => {
  if (typeof data == "object") {
    const childrens = [];
    for (const key in data) {
      childrens.push({
        label: key + ": " + data[key],
        children: buildJsonToElTreeData(data[key]),
      });
    }
    return childrens;
  } else {
    return [];
  }
};

/**
 * 处理后端返回菜单数据
 * @param {*} data
 * @returns
 */
export const menusToRouter = (data) => {
  if (data) {
    let result = [];
    data.forEach((item) => {
      let itemData = {
        path: item.menu_path,
        name: item.menu_path,
        component: () => import(`@/views/${item.component}.vue`),
        redirect: item.redirect,
        meta: {
          title: item.menu_name,
          icon: item.icon,
        },
        children: menusToRouter(item.children),
      };
      result.push(itemData);
    });
    return result;
  }
};

export const getToken = () => {
  return store.getters.getToken;
};

// 通过UA
export const getUserAgent = (ua) => {
  const browserInfo = {
    browser: "",
    version: "",
    os: "",
  };

  // 正则表达式用于匹配浏览器名称、版本和操作系统信息
  const browserRegex =
    /(?:(?:Firefox|Chrome|Safari|Opera|Edge)\/([\d.]+)|(?:Version\/([\d.]+).*?Safari))/;
  const osRegex =
    /(?:Windows NT (\d+)\.(\d+))|(?:Mac OS X (\d+)_(\d+)_(\d+))|(?:iPhone OS (\d+)_(\d+)_?(\d+)?)/;

  // 尝试匹配浏览器信息
  ua.replace(browserRegex, (match, browserVersion, safariVersion) => {
    browserInfo.browser = match.split("/")[0];
    browserInfo.version = browserVersion || safariVersion;
  });

  // 尝试匹配操作系统信息
  ua.replace(
    osRegex,
    (
      match,
      winMajorVersion,
      winMinorVersion,
      macOSVersion,
      macOSMajorVersion,
      macOSMinorVersion,
      iosMajorVersion,
      iosMinorVersion
    ) => {
      if (winMajorVersion) {
        browserInfo.os = `Windows ${winMajorVersion}.${winMinorVersion}`;
      } else if (macOSVersion) {
        browserInfo.os = `Mac OS ${macOSMajorVersion}_${macOSMinorVersion}_${macOSVersion}`;
      } else if (iosMajorVersion) {
        browserInfo.os = `iOS ${iosMajorVersion}.${iosMinorVersion || 0}`;
      }
    }
  );

  return browserInfo;
};

/**
 * base64 转 File
 * @param {String} base64
 * @returns
 */
export function base64ToFile(base64) {
  let file = null;

  // 浏览器兼容
  if (window.File != undefined) {
    let parsedBase64 = parseBase64(base64);
    let u8arr = base64ToUint8Array(base64);
    file = new File([u8arr], parsedBase64.mime.replace("/", "."), {
      type: parsedBase64.mime,
    });
  } else {
    file = blobToFile(base64ToBlob(base64));
  }

  return file;
}

export const formatMoney = (
  text,
  precision = 2,
  divPrecision = true,
  icon = "￥"
) => {
  //precision是保留小数位数，divPrecision 是否需要除以精度(也就是在原来的基础上除以精度)
  if (text === undefined || text === null || text === "" || isNaN(text)) {
    return "-";
  }
  let mulNum = 1;
  if (divPrecision && precision) {
    for (let i = 1; i <= precision; i++) {
      mulNum = mulNum * 10;
    }
  }
  let value = text / mulNum;
  if (precision) {
    value = value.toFixed(precision);
  }
  value =
    value &&
    value
      .toString()
      .replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));

  if (icon) {
    value = icon + value;
  }

  return value;
};

// https://vue3.youlai.tech/#/system/dict
// http://manage.thinkphp8.antdvue.rxthink.cn/system/loginlog
// https://snowy.xiaonuo.vip/sys/menu
// https://www.72crm.com/72crm/#/oa/task/subs/1?module=manage
